import { render, staticRenderFns } from "./OrganismAnchorsV2.vue?vue&type=template&id=354daf36&"
import script from "./OrganismAnchorsV2.vue?vue&type=script&lang=js&"
export * from "./OrganismAnchorsV2.vue?vue&type=script&lang=js&"
import style0 from "./OrganismAnchorsV2.vue?vue&type=style&index=0&id=354daf36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesCommonMoleculeAnchorV2: require('/app/components/molecules/common/MoleculeAnchorV2.vue').default})
